export const enum ROUTE {
  HOME = '/',
  PROJECT = '/projects/:projectId',
  PROJECT_MAPPING = '/projects/:projectId/mapping/:mappingId?',
}
